'use server'

import { randomUUID } from 'node:crypto'

import { z } from 'zod'

import { mutateDb } from '@/features/catalog/services/db.server'

export type InquiryState = {
  status: 'idle' | 'error' | 'success'
  message?: string
  fieldErrors?: Record<string, string | undefined>
}

const inquirySchema = z.object({
  name: z.string().trim().min(2, '이름을 입력해 주세요.').max(30),
  contact: z
    .string()
    .trim()
    .min(5, '답변 받을 연락처를 입력해 주세요.')
    .max(80),
  vehicle: z.string().trim().max(60),
  message: z.string().trim().min(5, '문의 내용을 입력해 주세요.').max(1000),
})

export async function submitInquiry(
  _prev: InquiryState,
  formData: FormData
): Promise<InquiryState> {
  const parsed = inquirySchema.safeParse({
    name: formData.get('name'),
    contact: formData.get('contact'),
    vehicle: formData.get('vehicle') ?? '',
    message: formData.get('message'),
  })
  if (!parsed.success) {
    const fields = z.flattenError(parsed.error).fieldErrors
    return {
      status: 'error',
      message: '입력 내용을 확인해 주세요.',
      fieldErrors: {
        name: fields.name?.[0],
        contact: fields.contact?.[0],
        message: fields.message?.[0],
      },
    }
  }
  await mutateDb((db) => {
    db.inquiries.unshift({
      id: randomUUID(),
      ...parsed.data,
      status: 'open',
      createdAt: new Date().toISOString(),
    })
  })
  return {
    status: 'success',
    message: '문의가 접수되었습니다. 남겨주신 연락처로 답변드리겠습니다.',
  }
}
